import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { NormalizeLabel, Label } from './MaybeLabelStyledComponents';

function LabelOrDiv(_ref) {
  var div = _ref.div,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["div", "children"]);

  if (div) return React.createElement("div", props, children);
  return React.createElement(NormalizeLabel, props, children);
}

LabelOrDiv.propTypes = {
  children: PropTypes.node,
  div: PropTypes.bool
};
LabelOrDiv.defaultProps = {
  children: null,
  div: false
};
var MaybeLabel = React.forwardRef(function (_ref2, ref) {
  var label = _ref2.label,
      children = _ref2.children,
      error = _ref2.error,
      labelAsDiv = _ref2.labelAsDiv,
      props = _objectWithoutProperties(_ref2, ["label", "children", "error", "labelAsDiv"]);

  if (!label) return React.createElement("span", props, children);
  return React.createElement(LabelOrDiv, _extends({
    div: labelAsDiv
  }, props, {
    ref: ref
  }), React.createElement(Label, {
    label: label,
    error: error
  }, label), children);
});
MaybeLabel.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
  label: PropTypes.string,
  labelAsDiv: PropTypes.bool
};
MaybeLabel.defaultProps = {
  children: null,
  error: false,
  label: null,
  labelAsDiv: false
};
export default MaybeLabel;